import React from 'react';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { StyledMultiSelect, HelperText } from './index.style';

const animatedComponents = makeAnimated();

const MultipleSelect = ({
  selectedOptions = [],
  defaultValue = [],
  options = [],
  placeholder,
  isLoading,
  onChange,
  formatOptionLabel,
  isMulti = true,
  typeHelperText = 'default',
  helperText = '',
  ...props
}) => (
  <StyledMultiSelect>
    <Select
      closeMenuOnSelect={false}
      isClearable={false}
      components={animatedComponents}
      isMulti={isMulti}
      defaultValue={defaultValue}
      value={selectedOptions}
      options={options}
      menuPortalTarget={document.body}
      formatOptionLabel={formatOptionLabel}
      onChange={onChange}
      isLoading={isLoading}
      placeholder={placeholder}
      {...props}
    />
    {helperText && <HelperText type={typeHelperText}>{helperText}</HelperText>}
  </StyledMultiSelect>
);

export default MultipleSelect;
